import { render, staticRenderFns } from "./BanlistSkeleton.vue?vue&type=template&id=3d539c5c&"
import script from "./BanlistSkeleton.vue?vue&type=script&lang=js&"
export * from "./BanlistSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BanlistSkeleton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports